import React from "react";

const SvgVilla = (props) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5" clip-path="url(#clip0_328_1982)">
      <path
        d="M25.35 21.2342C25.35 21.801 24.8898 22.2612 24.3204 22.2612H11.9704V23.2908C11.9704 24.4296 11.05 25.35 9.91379 25.35H6.82499C5.6888 25.35 4.76581 24.4296 4.76581 23.2908V22.2612H1.67958C1.1102 22.2612 0.649994 21.801 0.649994 21.2342C0.649994 20.6648 1.1102 20.2046 1.67958 20.2046H4.76581V19.175C4.76581 18.0388 5.6888 17.1158 6.82499 17.1158H9.91379C11.05 17.1158 11.9704 18.0388 11.9704 19.175V20.2046H24.3204C24.8898 20.2046 25.35 20.6648 25.35 21.2342Z"
        fill="currentColor"
      />
      <path
        d="M25.35 13C25.35 13.5694 24.8898 14.0296 24.3204 14.0296H21.2342V15.0592C21.2342 16.1954 20.3112 17.1158 19.175 17.1158H16.0862C14.95 17.1158 14.0296 16.1954 14.0296 15.0592V14.0296H1.67958C1.1102 14.0296 0.649994 13.5694 0.649994 13C0.649994 12.4306 1.1102 11.9704 1.67958 11.9704H14.0296V10.9408C14.0296 9.80461 14.95 8.88422 16.0862 8.88422H19.175C20.3112 8.88422 21.2342 9.80461 21.2342 10.9408V11.9704H24.3204C24.8898 11.9704 25.35 12.4306 25.35 13Z"
        fill="currentColor"
      />
      <path
        d="M0.649994 4.76581C0.649994 4.19901 1.1102 3.73622 1.67958 3.73622H4.76581V2.70922C4.76581 1.57042 5.6888 0.650024 6.82499 0.650024H9.91379C11.05 0.650024 11.9704 1.57042 11.9704 2.70922V3.73622H24.3204C24.8898 3.73622 25.35 4.19901 25.35 4.76581C25.35 5.33521 24.8898 5.79542 24.3204 5.79542H11.9704V6.82502C11.9704 7.96122 11.05 8.88422 9.91379 8.88422H6.82499C5.6888 8.88422 4.76581 7.96122 4.76581 6.82502V5.79542H1.67958C1.1102 5.79542 0.649994 5.33521 0.649994 4.76581Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_328_1982">
        <rect width="26" height="26" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgVilla;
